import { formatIntl as j, getCalendarLocale as y } from "../../lib/utils/calendar-utils/index.js";
import { C as h } from "../../chunks/Calendar.8LtDUeu3.js";
import { j as e } from "../../chunks/jsx-runtime.DGlMoOmv.js";
import * as w from "react";
import { createPortal as n } from "react-dom";
import { FormattedMessage as t } from "react-intl";
import { T as a } from "../../chunks/Text.BGhoO_e3.js";
import { C as v, a as N } from "../../chunks/CalendarAvailabilityKey.BkPxKc02.js";
const o = w.forwardRef(({
  children: s,
  ...l
}, r) => {
  const d = document.getElementsByClassName("calendar-container")?.[0];
  return n(/* @__PURE__ */ e.jsx("div", { ref: r, className: "tw-w-full tw-border-t tw-border-gray-200 tw-block tw-mt-12 tw-pt-12 tw-px-16 tw-pb-16", ...l, children: s }), d);
});
o.displayName = "CalendarFooter";
const p = () => /* @__PURE__ */ e.jsx("div", { className: "tw-p-4 tw-rounded-lg tw-max-w-full tw-mx-auto", children: /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-justify-start tw-gap-x-[88px] tw-gap-y-[8px] tw-items-start", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-y-3", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-items-center", children: [
      /* @__PURE__ */ e.jsx("span", { className: "tw-bg-yellow-600 tw-w-[4px] tw-h-[4px] tw-rounded-full tw-mr-8" }),
      /* @__PURE__ */ e.jsx(a, { typeface: "body-1-long", children: /* @__PURE__ */ e.jsx(t, { id: "0jbrpj", defaultMessage: [{
        type: 0,
        value: "Inquiry"
      }] }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-items-center", children: [
      /* @__PURE__ */ e.jsx("span", { className: "tw-bg-red-800 tw-w-[4px] tw-h-[4px] tw-rounded-full tw-mr-8" }),
      /* @__PURE__ */ e.jsx(a, { typeface: "body-1-long", children: /* @__PURE__ */ e.jsx(t, { id: "dqQE9k", defaultMessage: [{
        type: 0,
        value: "Offer"
      }] }) })
    ] })
  ] }),
  /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-flex-col tw-gap-y-3", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-items-center", children: [
      /* @__PURE__ */ e.jsx("span", { className: "tw-bg-blue-700 tw-w-[4px] tw-h-[4px] tw-rounded-full tw-mr-8" }),
      /* @__PURE__ */ e.jsx(a, { typeface: "body-1-long", children: /* @__PURE__ */ e.jsx(t, { id: "jDG/zH", defaultMessage: [{
        type: 0,
        value: "Requested"
      }] }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "tw-flex tw-items-center", children: [
      /* @__PURE__ */ e.jsx("span", { className: "tw-bg-green-800 tw-w-[4px] tw-h-[4px] tw-rounded-full tw-mr-8" }),
      /* @__PURE__ */ e.jsx(a, { typeface: "body-1-long", children: /* @__PURE__ */ e.jsx(t, { id: "hXfCth", defaultMessage: [{
        type: 0,
        value: "Booking"
      }] }) })
    ] })
  ] })
] }) });
export {
  h as Calendar,
  v as CalendarAvailabilityDayContent,
  N as CalendarAvailabilityKey,
  p as CalendarEventLegend,
  o as CalendarFooter,
  j as formatIntl,
  y as getCalendarLocale
};
//# sourceMappingURL=index.js.map
